// import {CONF_CLEINT_LOGO_PREFIX} from '@/constants'
import blankRespNum from '@/components/Resp/blankCounter.vue'
import messagesNum from '@/components/Resp/messagesCounter.vue'

// @ts-ignore
import messages from '@/lang/index'

export default [
  {
    name: messages.common.sidebar_links.wiki,
    icon: 'static/img/icons/sidebarmenu/info.svg',
    path: '/wiki/list',
    isLink: true
  },
  {
    name: messages.common.sidebar_links.polls,
    icon: 'static/img/icons/sidebarmenu/checkbox.svg',
    path: '/resp/list',
    isLink: true,
    nameAfter: blankRespNum
  },
  {
    name: messages.common.sidebar_links.messages,
    icon: 'static/img/icons/sidebarmenu/messenger.svg',
    path: '/messeger/hist',
    isLink: true
  },
  {
    name: messages.common.sidebar_links.schedule,
    icon: 'static/img/icons/sidebarmenu/calendar.svg',
    path: '/schedule',
    isLink: true
  },
  {
    name: messages.common.sidebar_links.settings,
    icon: 'static/img/icons/sidebarmenu/settings.svg',
    path: '/settings',
    nameAfter: messagesNum,
    children: [
      {
        name: messages.common.sidebar_links.messengers,
        path: '/settings/messengers',
        nameAfter: messagesNum
      },
      {
        name: messages.common.sidebar_links.news,
        path: '/settings/news'
      }
    ]
  }
];